<template>
    <section>
      <div v-if="resumeData">
          <div class="step-panle">
            <div class="rules-content">
              <div class="ivu-table ivu-table-border apps-entry-table">
                <div class="ivu-table-body">
                    <!-- <h3 style="padding:20px 0">单位信息</h3>
                    <table style="border:1px solid #e9eaec;border-collapse: collapse;width:100%">
                      <tbody class="iv-table-tbody">
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">入职单位</div></th>
                          <td>
                            <div class="ivu-table-cell" style="padding:8px">
                              <template v-if="!companyNameEdit">
                                {{resumeData.company_name||'未选择'}}
                                <Button type="info" size="small" @click="companyNameEdit=true">修改</Button>
                              </template>
                              <Select v-model="resumeData.company_name" @on-change="companyNameChange" v-else>
                                <Option value="浙江宇脉科技股份有限公司"></Option>
                                <Option value="杭州领优信息科技有限公司">杭州领优信息科技有限公司</Option>
                              </Select>
                            </div>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">入职类型</div></th>
                          <td>
                            <div class="ivu-table-cell" style="padding:8px">
                              <template v-if="!staffTypeEdit">
                                {{resumeData.staff_type||'未选择'}}
                                <Button type="info" size="small" @click="staffTypeEdit=true">修改</Button>
                              </template>
                              <Select v-model="resumeData.staff_type" @on-change="staffTypeChange" v-else>
                                <Option value="正式员工"></Option>
                                <Option value="实习生">实习生</Option>
                                <Option value="非正式员工(自由人)">非正式员工(自由人)</Option>
                              </Select>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table> -->
                    <h3 style="padding:20px 0">个人信息</h3>
                    <table style="border:1px solid #e9eaec;border-collapse: collapse;min-width:600px">
                      <tbody class="iv-table-tbody">
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">中文姓名</div></th>
                          <td>
                            <div class="ivu-table-cell">
                              {{resumeData.name||'未填写'}}
                            </div>
                          </td>
                          <th><div class="ivu-table-cell">英文姓名</div></th>
                          <td>
                            <div class="ivu-table-cell">
                              {{resumeData.ename||'未填写'}}
                            </div>
                          </td>
                          <td rowspan="3" width="100" style="border:1px solid #e9eaec;text-align:center">
                            <div class="resume-avatar" style="position:relative;height:144px;left:0;top:0;background:#eee">
                              <label for="avatarFile" style="position:absolute;top:0;left:0;width:100%;z-index:2">
                                <img :src="getImage(resumeData.avatar)" v-if="resumeData.avatar!=null" style="width:90px;height:134px;margin:5px;">
                              </label>
                            </div>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">出生年月</div></th>
                          <td>
                            <div class="ivu-table-cell">
                                {{resumeData.birthday||'未填写'}}
                            </div>
                          </td>
                          <th><div class="ivu-table-cell">性别</div></th>
                          <td>
                            <div class="ivu-table-cell">
                              {{resumeData.gender||'未填写'}}
                            </div>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">政治面貌</div></th>
                          <td>
                            <div class="ivu-table-cell">
                                {{resumeData.political_status||'未填写'}}
                            </div>
                          </td>
                          <th><div class="ivu-table-cell">身高</div></th>
                          <td>
                            <div class="ivu-table-cell">
                                {{resumeData.height||'未填写'}}
                            </div>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">所学专业</div></th>
                          <td>
                            <div class="ivu-table-cell">
                                {{resumeData.major||'未填写'}}
                            </div>
                          </td>
                          <th><div class="ivu-table-cell">最高学历</div></th>
                          <td colspan="3">
                            <div class="ivu-table-cell">
                                {{resumeData.education||'未填写'}}
                            </div>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">籍贯</div></th>
                          <td>
                            <div class="ivu-table-cell">
                                {{resumeData.origin_place||'未填写'}}
                            </div>
                          </td>
                          <th><div class="ivu-table-cell">户口所在地</div></th>
                          <td>
                            <div class="ivu-table-cell">
                                {{resumeData.reg_place||'未填写'}}
                            </div>
                          </td>
                          <td>
                            <div class="ivu-table-cell" style="text-align:center">
                              {{resumeData.hkxz}}
                            </div>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">家庭地址</div></th>
                          <td colspan="5">
                            <div class="ivu-table-cell">
                                {{resumeData.address||'未填写'}}
                            </div>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">家庭电话</div></th>
                          <td>
                            <div class="ivu-table-cell">
                                {{resumeData.tel||'未填写'}}
                            </div>
                          </td>
                          <th><div class="ivu-table-cell">身份证<br><span style="color:#999">(或护照号)</span></div></th>
                          <td colspan="3">
                            <div class="ivu-table-cell">
                                {{resumeData.id_number||'未填写'}}
                            </div>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">手机号码</div></th>
                          <td>
                            <div class="ivu-table-cell">
                                {{resumeData.mobile||'未填写'}}
                            </div>
                          </td>
                          <th><div class="ivu-table-cell">邮箱地址</div></th>
                          <td colspan="3">
                            <div class="ivu-table-cell">
                                {{resumeData.email||'未填写'}}
                            </div>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th><div class="ivu-table-cell">婚姻状况</div></th>
                          <td colspan="5">
                            <div class="ivu-table-cell">
                              {{resumeData.marital_status||'未填写'}}
                            </div>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th colspan="6" style="text-align:center"><div class="ivu-table-cell">学习经历</div></th>
                        </tr>
                        <tr>
                          <td colspan="6">
                              <table style="width:100%;border-collapse: collapse;">
                                <tbody>
                                  <tr class="ivu-table-row">
                                    <th style="width:130px"><div class="ivu-table-cell">时间</div></th>
                                    <th style="text-align:center;width:auto"><div class="ivu-table-cell"></div></th>
                                    <th style="text-align:center;width:120px"><div class="ivu-table-cell">学历</div></th>
                                    <th style="text-align:center;width:120px"><div class="ivu-table-cell">专业</div></th>
                                  </tr>
                                  <tr class="ivu-table-row" v-for="(item, index) in resumeData.edu_exp" :key="index">
                                    <td style="text-align:center">
                                      <div class="ivu-table-cell">
                                          {{item.time||'未填写'}}
                                      </div>
                                    </td>
                                    <td style="text-align:center">
                                      <div class="ivu-table-cell">
                                          {{item.con||'未填写'}}
                                      </div>
                                    </td>
                                    <td style="text-align:center">
                                      <div class="ivu-table-cell">
                                          {{item.edu||'未填写'}}
                                      </div>
                                    </td>
                                    <td style="text-align:center">
                                      <div class="ivu-table-cell">
                                          {{item.major||'未填写'}}
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th colspan="6" style="text-align:center"><div class="ivu-table-cell">工作经历</div></th>
                        </tr>
                        <tr>
                          <td colspan="6">
                              <table style="width:100%;border-collapse: collapse;">
                                <tbody>
                                  <tr class="ivu-table-row">
                                    <th style="text-align:center;width:130px"><div class="ivu-table-cell">时间</div></th>
                                    <th style="text-align:center;width:auto"><div class="ivu-table-cell">工作单位</div></th>
                                    <th style="text-align:center;width:120px"><div class="ivu-table-cell">职务</div></th>
                                    <th style="text-align:center;width:120px"><div class="ivu-table-cell">离职原因</div></th>
                                  </tr>
                                </tbody>
                                <tbody v-for="(item, index) in resumeData.work_exp" :key="index">
                                  <tr class="ivu-table-row">
                                    <td style="text-align:center">
                                      <div class="ivu-table-cell">
                                          {{item.time||'未填写'}}
                                      </div>
                                    </td>
                                    <td style="text-align:center">
                                      <div class="ivu-table-cell">
                                          {{item.unit||'未填写'}}
                                      </div>
                                    </td>
                                    <td style="text-align:center">
                                      <div class="ivu-table-cell">
                                          {{item.post||'未填写'}}
                                      </div>
                                    </td>
                                    <td style="text-align:center">
                                      <div class="ivu-table-cell">
                                          {{item.reason||'未填写'}}
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                  <td colspan="4">
                                    <div class="ivu-table-cell" style="padding:5px;">
                                      {{item.detail}}
                                    </div>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th colspan="6" style="text-align:center"><div class="ivu-table-cell">特殊技能</div></th>
                        </tr>
                        <tr class="ivu-table-row">
                          <th colspan="6" style="text-align:center"><div class="ivu-table-cell">获得的证书情况</div></th>
                        </tr>
                        <tr>
                          <td colspan="6">
                            <table style="width:100%;border-collapse: collapse;">
                              <tbody>
                                <tr class="ivu-table-row">
                                  <th style="text-align:center;width:130px"><div class="ivu-table-cell">证书名称</div></th>
                                  <th style="text-align:center;width:130px"><div class="ivu-table-cell">获得时间</div></th>
                                  <th style="text-align:center;width:auto"><div class="ivu-table-cell">颁发单位</div></th>
                                  <th style="text-align:center;width:130px"><div class="ivu-table-cell">证书是否在公司备案</div></th>
                                </tr>
                                <tr class="ivu-table-row" v-for="(item, index) in resumeData.certificate" :key="index">
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.name||'未填写'}}
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.time||'未填写'}}
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.unit||'未填写'}}
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                      {{item.redord||'未填写'}}
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th colspan="6" style="text-align:center"><div class="ivu-table-cell">紧急情况联系人</div></th>
                        </tr>
                        <tr>
                          <td colspan="6">
                            <table style="width:100%;border-collapse: collapse;">
                              <tbody>
                                <tr class="ivu-table-row">
                                  <th style="text-align:center;width:100px;"><div class="ivu-table-cell">姓名</div></th>
                                  <th style="text-align:center;width:100px;"><div class="ivu-table-cell">关系</div></th>
                                  <th style="text-align:center;width:auto"><div class="ivu-table-cell">联系地址</div></th>
                                  <th style="text-align:center;width:100px;"><div class="ivu-table-cell">联系电话</div></th>
                                  <th style="text-align:center;width:100px;"><div class="ivu-table-cell">私人邮箱</div></th>
                                </tr>
                                <tr class="ivu-table-row" v-for="(item, index) in resumeData.content" :key="index">
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.name||'未填写'}}
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.relation||'未填写'}}
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.address||'未填写'}}
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.tel||'未填写'}}
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.email||'未填写'}}
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th colspan="6" style="text-align:center"><div class="ivu-table-cell">家庭成员</div></th>
                        </tr>
                        <tr>
                          <td colspan="6">
                            <table style="width:100%;border-collapse: collapse;">
                              <tbody>
                                <tr class="ivu-table-row">
                                  <th style="text-align:center;width:100px;"><div class="ivu-table-cell">姓名</div></th>
                                  <th style="text-align:center;width:100px;"><div class="ivu-table-cell">关系</div></th>
                                  <th style="text-align:center;width:100px;"><div class="ivu-table-cell">联系电话</div></th>
                                  <th style="text-align:center;width:auto"><div class="ivu-table-cell">工作单位</div></th>
                                </tr>
                                <tr class="ivu-table-row" v-for="(item, index) in resumeData.family" :key="index">
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.name||'未填写'}}
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.relation||'未填写'}}
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.tel||'未填写'}}
                                    </div>
                                  </td>
                                  <td style="text-align:center">
                                    <div class="ivu-table-cell">
                                        {{item.unit||'未填写'}}
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr class="ivu-table-row">
                          <th colspan="6" style="text-align:center"><div class="ivu-table-cell">备注</div></th>
                        </tr>
                        <tr>
                          <td colspan="6">
                            <div class="ivu-table-cell" style="padding:8px">
                              {{resumeData.remarks||'未填写'}}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                     <h3 style="padding:20px 0">银行信息 <small></small></h3>
                  <table style="border:1px solid #e9eaec;border-collapse: collapse;width:100%" v-if="resumeData.bank">
                    <tbody class="iv-table-tbody">
                      <tr class="ivu-table-row">
                        <th><div class="ivu-table-cell">开户姓名</div></th>
                        <td>
                          <div class="ivu-table-cell" style="padding:8px">
                              {{resumeData.bank.name||'未填写'}}
                          </div>
                        </td>
                        <th><div class="ivu-table-cell">开户行</div></th>
                        <td>
                          <div class="ivu-table-cell" style="padding:8px">
                              {{resumeData.bank.bank_name||'未填写'}}
                          </div>
                        </td>
                      </tr>
                      <tr class="ivu-table-row">
                        <th><div class="ivu-table-cell">行号</div></th>
                        <td>
                          <div class="ivu-table-cell" style="padding:8px">
                              {{resumeData.bank.number||'未填写'}}
                          </div>
                        </td>
                        <th><div class="ivu-table-cell">银行卡号</div></th>
                        <td>
                          <div class="ivu-table-cell" style="padding:8px">
                              {{resumeData.bank.card_number||'未填写'}}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      <div class="apps-entry-content">
          <div class="step-panle">
            <div class="rules-head">
              <div style="float:right">
                <Button type="default" v-if="isToExamine">已审核</Button>
              </div>
              <h1 style="text-align:left">资料</h1>
            </div>
            <div class="rules-content">
              <h4>身份证</h4>
              <div class="upload-box">
                  <div class="upload-item">
                    <div class="upload-item-wrap">
                      <div class="upload-item-img" @click="viewImg(resumeFiles.id_card_f)">
                          <template v-if="resumeFiles.id_card_f != null">
                              <img :src="resumeFiles.id_card_f" style="height:100%">
                          </template>
                      </div>
                    </div>
                  </div>
                  <div class="upload-item">
                    <div class="upload-item-wrap">
                        <div class="upload-item-img" @click="viewImg(resumeFiles.id_card_b)">
                            <template v-if="resumeFiles.id_card_b != null">
                                <img :src="resumeFiles.id_card_b" style="height:100%">
                            </template>
                        </div>
                    </div>
                  </div>
              </div>
              <h4>学历证</h4>
              <div class="upload-box">
                  <div class="upload-item">
                      <div class="upload-item-wrap">
                          <div class="upload-item-img" @click="viewImg(resumeFiles.education_certificate)">
                              <template v-if="resumeFiles.education_certificate != null">
                                  <img :src="resumeFiles.education_certificate" style="height:100%">
                              </template>
                          </div>
                      </div>
                  </div>
              </div>
              <h4>学位证</h4>
              <div class="upload-box">
                  <div class="upload-item">
                    <div class="upload-item-wrap">
                        <div class="upload-item-img" @click="viewImg(resumeFiles.degree_certificate)">
                            <template v-if="resumeFiles.degree_certificate != null">
                                <img :src="resumeFiles.degree_certificate" style="height:100%">
                            </template>
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
            <div class="rules-foot" style="text-align:center;clear:both;position:static">
              <Alert style="width:300px;margin:0 auto;text-align:left;margin-bottom:15px" v-if="entryInfo.type!=''">
                审核历史
                <template slot="desc">
                  {{this.entryInfo.remarks}}
                </template>
              </Alert>
            </div>
          </div>
        </div>
        <Modal v-model="viewImgModel" width="90%" :styles="{'marginBottom': '40px'}" footer-hide>
          <img :src="viewImgPath" width="100%">
        </Modal>
      </section>
</template>

<script>
  export default {
    name: 'userresume',
    components: {
    },
    props: {
      resumeData: {
        type: Object
      },
      resumeFiles: {
        type: Object,
        default: function () {
          return {
            id_card_f: null,
            id_card_b: null,
            education_certificate: null,
            degree_certificate: null
          }
        }
      }
    },
    data () {
      let token = localStorage.getItem('token')
      return {
        token: token,
        defaultList: [],
        isToExamine: false,
        contractPath: null,
        companyNameEdit: false,
        staffTypeEdit: false,
        viewImgModel: false,
        viewImgPath: null,
        is_social_security: 0,
        entryInfo: {
          type: '',
          job_name: '',
          salary: '',
          remarks: '',
          test_salary: '',
          time_limit: 3,
          social_security: '',
          social_security_city: '',
          bole: ''
        }
      }
    },
    mounted () {
    },
    methods: {
      viewContract () {
        // let dom = document.getElementById('contractHtml')
        // let uid = this.$route.params.id
        // let html = dom.innerHTML
      },
      editContract () {
        // let data = {
        //   'user_id': this.$route.params.id,
        //   'sign_info': JSON.stringify(this.contractData)
        // }
        if (this.contractData.name === '') {
          this.$Message.error('请输入乙方姓名')
          return false
        }
        if (this.contractData.birthday === '') {
          this.$Message.error('请输入乙方出生日期')
          return false
        }
        if (this.contractData.gender === '') {
          this.$Message.error('请输入乙方性别')
          return false
        }
        if (this.contractData.phone === '') {
          this.$Message.error('请输入乙方联系电话')
          return false
        }
        if (this.contractData.id_number === '') {
          this.$Message.error('请输入乙方身份证号码')
          return false
        }
        if (this.contractData.job_name === '') {
          this.$Message.error('请输入您从事的工作')
          return false
        }
        if (this.contractData.signature === null) {
          this.$Message.error('请您签名')
          return false
        }
        if (this.contractData.sign_year === '') {
          this.$Message.error('请输入签约日期')
          return false
        }
        if (this.contractData.sign_month === '') {
          this.$Message.error('请输入签约日期')
          return false
        }
        if (this.contractData.sign_day === '') {
          this.$Message.error('请输入签约日期')
          return false
        }
      },
      viewImg (img) {
        this.viewImgModel = true
        this.viewImgPath = img
      },
      getImage (path) {
        return `/api/console/file?path=${path}&token=${this.token}`
      }
    }
  }
</script>
<style>
  .apps-entry-table .ivu-table-cell{padding:0 6px;}
  .apps-entry-table .ivu-form-item{margin:0 auto;}
  .apps-entry-table .ivu-form-item-error-tip{top:5px;right:5px;left:auto;}
  .apps-entry-table.ivu-table:before{display: none;}
  .apps-entry-table th{width:80px;text-align: right}
  .apps-entry-steps.ivu-steps .ivu-steps-head,
  .apps-entry-steps.ivu-steps .ivu-steps-title{background: none;}
</style>
<style scoped>
  .avatar-file{display: none}
  .apps-entry{
    margin: auto 0;
  }
  .apps-entry-content{
    padding: 0;
    background-color: #fff;
    border-radius: 10px;
    margin-bottom: 40px;
    position: relative;
  }
  .apps-entry-title{
    margin-bottom: 10px;
  }
  .apps-entry-steps-buttons{
    padding: 5px 34px;
  }
  .rules-head{
    border-bottom: 1px solid #eee;
    padding:20px 20px 10px;
  }
  .rules-foot{
    width: 100%;
    padding: 20px 0;
    border-top: 1px solid #eee;
    position: absolute;
    bottom: 0;
  }
  .rules-content{
    padding: 10px 20px 100px;
    border-width: 1px 0;
  }
  .rules-content h4{margin:10px 0;color:#666;}
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }
  .list-enter, .list-leave-to
  /* .list-leave-active for below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(30px);
  }
  .upload-box{margin-bottom: 20px;}
  .upload-item{
    width:256px;
    display: inline-block;
    margin-left: 15px;
  }
  .upload-item-wrap{
    width: 256px;
    height: 160px;
    overflow: hidden;
    background-color: #f7f7f7
  }
  .upload-item-img{
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 6px;
  }
  .upload-item-img,
  .upload-item-img img{height: 100%}
  .upload-item-cover{
    width: 100%;
    font-size:18px;
    color:#999;
    line-height: 40px;
    position: absolute;
    top: 60px;
  }
  .upload-item-cover i{vertical-align: middle;color:#999;}
</style>
